<template>
    <base-gantt
        ref="basegantt"
        :tasks="tasks"
        :range="range"
    ></base-gantt>
</template>

<script>

    import BaseGantt from './BaseGantt';
    import moment from 'moment';
    import toCurrency from '../../filters/toCurrency';
    import Lang from '../../Lang';

    export default {

        components: {
            BaseGantt,
        },

        methods: {
            setDefaultConfig(){
                gantt.config.date_grid = "%Y-%m-%d ";
                gantt.config.xml_date = "%Y-%m-%d %H:%i:%s";
                gantt.config.duration_unit = "day";
                gantt.config.work_time = true;
                gantt.config.scale_unit = "month";
                gantt.config.step = 1;
                gantt.config.date_scale = "%F, %Y";
                //gantt.config.min_column_width = 20;
                gantt.config.scale_height = 50;
                gantt.config.row_height = 22;
                gantt.config.grid_width = 500;
                //gantt.config.static_background = true;
//                gantt.config.autosize = "y"; // x/y
            },
            setColumns() {
                // Setup a columns array
                let columns = [];
                // Attach basic columns
                columns.push({name:"text",label:Lang.get("tasks.task"),tree:true,width:'*',resize:true});
                columns.push({name:"start_date",label:Lang.get("global.startdate"),align:"center",resize:true,template:function(obj){
                        return moment(obj.start_date).locale('nl').format("L");
                    }});
                columns.push({name:"duration",label:Lang.get("global.days"),align:"center",width:35,resize:true});
                // Check budget
                if (this.showBudget) {
                    // Add the budget column
                    columns.push({name:"budget",label:Lang.get("tasks.budget"),align:"right",width:90,resize:true,template(obj){
                            if ((!obj.budget && obj.budget !== 0) || obj.budget === '') { return ''; }
                            if (obj.budget < 0) {
                                return '<span style="color:red;">' + toCurrency(obj.budget) + '</span>';
                            }
                            return toCurrency(obj.budget);
                        }});
                }
                // Check buttons
                if (this.showButtons) {
                    // Add the on/off buttons
                    columns.push({name:"on",label:Lang.get("global.active"),width:40,align:"center",template(obj){
                            // Check if is project
                            if (obj.is_project === true) { return ""; }
                            // Check if active
                            if (obj.active === true) {
                                return '<a href="javascript:void(0);" style="color:#000;"><i class="fa fa-toggle-on"></i></a>';
                            } else {
                                return '<a href="javascript:void(0);" style="color:#000;"><i class="fa fa-toggle-off"></i></a>';
                            }
                        }});
                    // Add the other buttons
                    columns.push({
                        name:"buttons",
                        label:'',
                        width:30,
                        template:function(obj){
                            if (!obj.is_project && obj.is_task && !obj.deletable) {
                                return '';
                            }
                            return !obj.is_project ?
                                '<a href="javascript:void(0);" style="color:#000;"><i class="fa fa-times"></i></a>' :
                                '<a href="javascript:void(0);" style="color:#000;"><i class="fa fa-plus"></i></a>';
                        }
                    });
                }
                // Assign the columns to gantt.
                gantt.config.columns = columns;
            },
            attachEventHandlers() {
                // On task click handler
                gantt.attachEvent("onTaskClick", (id, link) => {
                    this.$emit("task-clicked", id, link);
                    return true;
                });
                // Task double click handler
                gantt.attachEvent("onTaskDblClick", (id, link) => {
                    this.$emit("task-dblclick", id, link);
                });
                // After task drag. This is a combined handler for all different kinds of drag events. Among them is the progress draggable.
                gantt.attachEvent("onAfterTaskDrag", (id, mode, link) => {
                    if (mode === "progress") {
                        this.$emit("updated-task-percentage", id, link);
                    }
                });
                // Before task drag. This is a combined handler for all different kinds of drag events. Among them is the progress draggable.
                gantt.attachEvent("onBeforeTaskDrag", (id, mode, link) => {
                    if (mode === "progress") {
                        // Check task_id first. This can be null.
                        if (id === null || false === this.showButtons) {
                            return false;
                        }
                        // Get the task
                        let task = gantt.getTask(id);
                        // Check if project
                        return !task.is_project;
                    }
                    return true;
                });
            },
        },

        mounted() {
            this.setDefaultConfig();
            this.setColumns();
            this.attachEventHandlers();
            this.$refs.basegantt.startGantt();
            this.$refs.basegantt.defaultZoom();
        },

        name: "GanttTasks",

        props: {
            tasks: {
                required:true,
                type:Object,
                default:{
                    data: [],
                    links: [],
                }
            },
            range: {
                required:true,
                type:Array,
                default:['',''],
            },
            showBudget: {
                type:Boolean,
                default:false,
            },
            showButtons: {
                type:Boolean,
                default:false,
            },
        },

    }

</script>

<style>
    @import "dhtmlx-gantt/codebase/dhtmlxgantt.css";
</style>
